import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { useDictionary } from '@/lib/i18n'
import HeroSection from '@/components/landing/hero-section'
import StatsStrip from '@/components/landing/stats-strip'
import StorySection from '@/components/landing/story-section'
import CraftSection from '@/components/landing/craft-section'
import TickerBand from '@/components/landing/ticker-band'
import RacingSection from '@/components/landing/racing-section'
import TimeToFinishSection from '@/components/landing/time-to-finish-section'
import AeroSection from '@/components/landing/aero-section'
import EngineeringSection from '@/components/landing/engineering-section'
import GallerySection from '@/components/landing/gallery-section'
import SpecsSection from '@/components/landing/specs-section'
import GeometrySection from '@/components/landing/geometry-section'
import RegisterSection from '@/components/landing/register-section'

const Home: FC = (): ReactNode => {
    const t = useDictionary()

    return (
        <Layout>
            <Seo description={t.meta.description} />

            <HeroSection />
            <StatsStrip />
            <StorySection />
            <CraftSection />
            <TickerBand />
            <RacingSection />
            <TimeToFinishSection />
            <AeroSection />
            <EngineeringSection />
            <GallerySection />
            <SpecsSection />
            <GeometrySection />
            <RegisterSection />
        </Layout>
    )
}

export default Home
